import {Component, Input, OnInit} from '@angular/core';
import {Chat, Participant} from "../../state/chats/chat.model";
import {NgIf} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import * as UserSelectors from "../../state/users/users.selector";
import * as AuthSelectors from "../../state/auth/auth.selector";
import * as ChatSelectors from "../../state/chats/chat.selector";
import {User} from "../../auth/primitives/user";
import {Store} from "@ngrx/store";
import {FilesService} from "../../services/files/files.service";
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {ChatActions} from "../../state/chats/chatActions";

@Component({
  selector: 'chats-bar-chat-item',
  standalone: true,
  imports: [
    NgIf,
    Base64ImageComponent
  ],
  templateUrl: './chats-bar-chat-item.component.html',
  styleUrl: './chats-bar-chat-item.component.scss'
})
export class ChatsBarChatItemComponent implements OnInit {
  @Input() chat!: Chat;   // or: any if you don’t have a model yet
  user: User
  otherGuy: User = null
  hovered = false

  participants: Participant[] = []
  chatImageBase64: string
  unreadMessageCount: number = 0
  lastMessageText: string = ""

  constructor(
      private router: Router,
      private store: Store,
      private route: ActivatedRoute,
      private fileService: FilesService
  ) {
  }

  ngOnInit() {
    this.store.select(AuthSelectors.selectUser).subscribe(async (user) => {
      this.user = user
      await this.gotParticipantsAndUser()
    })
    this.store.select(ChatSelectors.selectParticipantsForChat(this.chat.id)).subscribe(async (participants) => {
      this.participants = participants
      await this.gotParticipantsAndUser()
    })
  }


  async gotParticipantsAndUser() {
    if ((!this.user) || this.participants.length === 0) {
      return
    }
    let participantIds = this.participants.map(part => part.participant_id)
    this.store.select(UserSelectors.selectUsersByIds(participantIds)).subscribe((users) => {
      users.forEach(async user => {
        if (user.id != this.user.id && users.length == 2) {
          const serverFile = await this.fileService.getFile(user.profile_image_file_id)
          this.chatImageBase64 = serverFile.fileData
          this.otherGuy = user
        }
      })
    })
    this.store.select(ChatSelectors.selectUnreadMessagesForChat(this.chat.id, this.user.id)).subscribe((messages) => {
      this.unreadMessageCount = messages?.length ?? 0
      this.lastMessageText = messages?.[messages.length - 1]?.text ?? ""
    })
  }


  mouseEntered() {
    this.hovered = true
  }

  mouseLeft() {
    this.hovered = false
  }

  openChat() {
    this.router.navigate(
        [{outlets: {'left-pane': "chat"}}],
        {
          queryParams: {
            chatId: this.chat.id,
          },
          queryParamsHandling: 'merge' // optional but common
        })
  }
}
